import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { CloudOff as CloudOffIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { APEX_K9_MARK } from '../../../shared/branding/apexK9';

/**
 * Full-screen state shown when the user is offline and tries to access a
 * route that isn't on the offline whitelist. We don't try to fake server
 * data — we just say so plainly and offer a clear way back.
 */
export const OfflineUnavailable: React.FC<{
  homePath?: string;
  homeLabel?: string;
  detail?: string;
}> = ({
  homePath = '/k9-ops/quick-menu',
  homeLabel = `Back to ${APEX_K9_MARK} Quick Menu`,
  detail,
}) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper
        elevation={2}
        sx={{
          p: 4,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'warning.light',
            color: 'warning.contrastText',
          }}
        >
          <CloudOffIcon sx={{ fontSize: 36 }} />
        </Box>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
          This feature isn&rsquo;t available offline
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {detail ??
            `Reconnect to a network to access this page. Your offline-ready ${APEX_K9_MARK} tools remain available from the quick menu.`}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(homePath)}
          sx={{ mt: 1 }}
        >
          {homeLabel}
        </Button>
      </Paper>
    </Container>
  );
};

export default OfflineUnavailable;
